

















































import Vue from 'vue';
import CustomType from '../../src/types/vue';
import FormInput from '../components/form/Input.vue';
import FormTextarea from '../components/form/Textarea.vue';
import FormSelect from '../components/form/Select.vue';
import FormCheckbox from '../components/form/Checkbox.vue';

export interface ComponentApp extends Vue {
  formData: FormData
  listePays: Array<{ key: string, value: string }>
  listeCategories: Array<{ key: string, value: string}>
  locale: string
  isValidNom: Boolean
  isValidPrenom: Boolean
  isValidTelephone: Boolean
  isValidEmail: Boolean
  isValidRaisonSociale: Boolean
  isValidAdresse: Boolean
  isValidCodePostal: Boolean
  isValidVille: Boolean
  isValidPays: Boolean
  isValidCategories: Boolean
  isValidMarques: Boolean
  isValidPaysExpedition: Boolean
  isValidForm: Boolean
}

class FormData {
  Nom: string = "";
  Prenom: string = "";
  Telephone: string = "";
  Email: string = "";
  RaisonSociale: string = "";
  Adresse: string = "";
  Cp: string = "";
  Ville: string = "";
  Pays: string = "";
  Categories: Array<number> = [];
  Marques: string = "";
  PaysExpedition: string = "";
  IsoPays: string = "";
  IsoPaysExpedition: string = "";
}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'Formulaire',
  props: {
  },
  data() {
    return {
      formData: new FormData(),
      listePays: [],
      listeCategories: [],

      isValidNom: false,
      isValidPrenom: false,
      isValidTelephone: false,
      isValidEmail: false,
      isValidRaisonSociale: false,
      isValidAdresse: false,
      isValidCodePostal: false,
      isValidVille: false,
      isValidPays: false,
      isValidCategories: false,
      isValidMarques: true,
      isValidPaysExpedition: false,
    }
  },
  computed: {
    isValidForm: function () {
        if(this.isValidAdresse && this.isValidCategories && this.isValidCodePostal && this.isValidEmail && this.isValidMarques && this.isValidNom && this.isValidPays
          && this.isValidPaysExpedition && this.isValidPrenom && this.isValidRaisonSociale && this.isValidTelephone && this.isValidVille )
          return true;

        return false;
    },
    locale: function(){
        return this.$store.state.locale;
    }
  },
  methods: {
    sendForm: function(){
      if(this.isValidForm){
        this.$http.post('https://api.super-vision.fr/SvDataServiceRestFullEu.svc/SaveForm', { data: this.formData }).then((response) => {
           alert(this.translate(this.$language, "success"));
           this.formData = new FormData();
        }, (response) => {
           alert(this.translate(this.$language, "error"));
        });
      }else{
        alert(this.translate(this.$language, "invalide"));
      }
    },
    updateNom: function (val, status) {
      this.formData.Nom = val;
      this.isValidNom = status;
    },
    updatePrenom: function (val, status) {
      this.formData.Prenom = val;
      this.isValidPrenom = status;
    },
    updateTelephone: function (val, status) {
      this.formData.Telephone = val;
      this.isValidTelephone= status;
    },
    updateEmail: function (val, status) {
      this.formData.Email = val;
      this.isValidEmail = status;
    },
    updateRaisonSociale: function (val, status) {
      this.formData.RaisonSociale = val;
      this.isValidRaisonSociale = status;
    },
    updateAdresse: function (val, status) {
      this.formData.Adresse = val;
      this.isValidAdresse= status;
    },
    updateCodePostal: function (val, status) {
      this.formData.Cp = val;
      this.isValidCodePostal = status;
    },
    updateVille: function (val, status) {
      this.formData.Ville = val;
      this.isValidVille = status;
    },
    updatePays: function (val, status) {
      this.formData.IsoPays = val;
      var pays = this.listePays.find((x) => x.key == this.formData.IsoPays);
      this.formData.Pays = (pays as any).value;

      this.isValidPays = status;
    },
    updateCategories: function (val, status) {
      this.formData.Categories = val;
      this.isValidCategories = status;
    },
    updateMarques: function (val, status) {
      this.formData.Marques = val;
      this.isValidMarques = status;
    },
    updatePaysExpedition: function (val, status) {
      this.formData.IsoPaysExpedition = val;
      var paysExpe = this.listePays.find((x) => x.key == this.formData.IsoPaysExpedition);
      this.formData.PaysExpedition = (paysExpe as any).value;

      this.isValidPaysExpedition = status;
    },
  },
  watch: {
    locale: function(val){
      let self = this;

      this.$http.get("https://www.super-vision.eu/javascript/ISO_PAYS.json").then((response) => {
			var datas = response.data as Array<Object>;
			self.listePays = [];
			datas.forEach(function(value, index){
          		self.listePays.push({key: value["code_iso"], value: (self.locale == "fr")? value["libelle_fr"] : value["libelle_en"] });
			});

      }, (response) => {
        console.log('erreur', response);
      });
    }
  },
  components: {
    FormInput,
    FormTextarea,
    FormSelect,
    FormCheckbox
  },
  beforeMount() {
    this.listeCategories = [
      { key: "Verre", value: "verre"},
      { key: "Montures", value: "montures"},
      { key: "Montures solaires", value: "montures_solaires"},
      { key: "Lentilles", value: "lentilles"},
      { key: "Solutions", value: "solutions"},
      { key: "Instruments optique & mesure", value: "instruments_optique_mesure"},
      { key: "Basse vision", value: "basse_vision"},
      { key: "Accessoires lunettes", value: "accessoires_lunettes"},
      { key: "Materiel & outillage", value: "materiel_outillage"},
      { key: "Montage & réparation", value: "montage_reparation"},
      { key: "Informatique", value: "informatique"},
      { key: "Agencement de magasin", value: "agencement_magasin"},
      { key: "Services", value: "services"},
      { key: "Autres", value: "autres"}
    ]

    let self = this;

    this.$http.get('https://www.super-vision.eu/javascript/ISO_PAYS.json').then((response) => {
      var datas = response.data as Array<Object>;
      self.listePays = [];
      datas.forEach(function(value, index){
    	self.listePays.push({key: value["code_iso"], value: (self.locale == "fr")? value["libelle_fr"] : value["libelle_en"] });
      });

    }, (response) => {
      console.log('erreur', response);
    });
  },
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/modules/Formulaire.vue